(function(){
const CFG=JSON.parse(document.getElementById('ppr-config').textContent);
const $=s=>document.querySelector(s);
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const money=n=>'$'+(+n).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
const store={get(k,d){try{return JSON.parse(localStorage.getItem(k))??d}catch(e){return d}},set(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}};
const CATS={
  rack:{n:'Rack & Pinions',s:'Rack & Pinion'},
  shock:{n:'Shocks y struts',s:'Shock'},
  alternador:{n:'Alternadores',s:'Alternador'},
  radiador:{n:'Radiadores',s:'Radiador'},
  starter:{n:'Starters',s:'Starter'},
  bomba:{n:'Bombas de power steering',s:'Bomba P/S'},
  booster:{n:'Boosters de frenos',s:'Booster'}
};
const ORDER=['rack','shock','alternador','radiador','starter','bomba','booster'];
const img=c=>CFG.a+'ppr-'+(CATS[c]?c:'rack')+'.webp';
const TYPE2CAT={'rack & pinion':'rack','alternador':'alternador','starter':'starter','radiador':'radiador','bomba de power steering':'bomba','booster':'booster','shock absorber':'shock'};
const typeCat=t=>TYPE2CAT[(t||'').toLowerCase()]||null;

/* ---------- toast ---------- */
let tt;function toast(m){const t=$('#toast');if(!t)return;t.textContent=m;t.classList.add('on');clearTimeout(tt);tt=setTimeout(()=>t.classList.remove('on'),2200)}

/* ---------- fetch limpio ----------
   La app Fee Rules ("Canteen") reemplaza window.fetch y, en cada cambio del carrito, quita y vuelve a
   poner sus cargos; con un carrito AJAX eso entra en bucle (cientos de /cart.js, 429 de Shopify y
   "Maximum call stack size exceeded"). La web usa el fetch nativo de un iframe vacío, que la app no toca,
   y calcula ella misma los cargos de core con las reglas de la app (window.Canteen.quantityRules). */
const NF=(()=>{try{const f=document.createElement('iframe');f.hidden=true;f.setAttribute('aria-hidden','true');f.tabIndex=-1;
  document.documentElement.appendChild(f);const w=f.contentWindow;
  if(w&&typeof w.fetch==='function')return (u,o)=>w.fetch(new URL(u,location.href).href,o);}catch(e){}
  return (u,o)=>fetch(u,o)})();
const JH={'Content-Type':'application/json',Accept:'application/json'};

/* ---------- carrito de Shopify ---------- */
let CART={items:[],item_count:0,total_price:0};
const isFee=it=>/fee/i.test(it.product_type||'');
const parts=()=>CART.items.filter(i=>!isFee(i));
const inCart=vid=>parts().some(i=>i.variant_id==vid);
function feeRules(){const q=window.Canteen&&window.Canteen.quantityRules;
  return Array.isArray(q)?q.filter(r=>r&&r.id&&Array.isArray(r.products)).map(r=>({id:+r.id,price:parseFloat(r.price)||0,set:new Set(r.products.map(Number))})):[]}
// Fee Rules quita los cargos mientras se navega y los añade al pulsar Pagar (clona los botones name="checkout").
// Aquí solo se calcula cuánto core se va a cobrar, para mostrarlo antes de pagar.
function coreEstimate(){
  const rules=feeRules();let n=0,total=0;
  parts().forEach(it=>{const r=rules.find(r=>r.set.has(+it.variant_id));if(r){n+=it.quantity;total+=it.quantity*r.price}});
  return {n,total};
}
async function fetchCart(){try{CART=await (await NF('/cart.js',{headers:{Accept:'application/json'}})).json()}catch(e){}}
async function loadCart(){await fetchCart();drawCart()}
async function addToCart(vid,qty){
  const r=await NF('/cart/add.js',{method:'POST',headers:JH,body:JSON.stringify({items:[{id:+vid,quantity:qty||1}]})});
  if(!r.ok){let m='No se pudo añadir.';try{m=(await r.json()).description||m}catch(e){}throw new Error(m)}
  // un carrito recién creado a veces tarda en devolver la línea: reintenta un par de veces
  for(let t=0;t<3;t++){await loadCart();if(inCart(vid))break;await new Promise(r=>setTimeout(r,500))}
}
async function changeLine(key,qty){
  await NF('/cart/change.js',{method:'POST',headers:JH,body:JSON.stringify({id:key,quantity:qty})});
  await loadCart();
}
function drawCart(){
  const n=parts().reduce((a,i)=>a+i.quantity,0),c=$('#count');
  if(c){c.hidden=!n;c.textContent=n}
  const L=$('#lines');if(!L)return;
  L.innerHTML=CART.items.length?CART.items.map(it=>{const cat=typeCat(it.product_type);
    if(isFee(it))return `<div class="line fee"><span class="feeic" aria-hidden="true">↺</span><div><div class="t">Core reembolsable</div><div class="k">${it.quantity} × ${money(it.final_price/100)} · se devuelve al entregar la pieza vieja</div></div><b class="mono">${money(it.final_line_price/100)}</b></div>`;
    return `<div class="line"><img src="${cat?img(cat):(it.image||img('rack'))}" alt=""><div><a class="t" href="${esc(it.url)}">${esc(it.sku||it.product_title)}</a><div class="k">${esc(it.product_type||it.product_title)} · ${money(it.final_price/100)}</div>
    <div class="qty"><button data-d="-1" data-k="${esc(it.key)}" data-q="${it.quantity}" aria-label="Menos">−</button><span>${it.quantity}</span><button data-d="1" data-k="${esc(it.key)}" data-q="${it.quantity}" aria-label="Más">+</button></div></div>
    <b class="mono">${money(it.final_line_price/100)}</b></div>`}).join(''):`<p style="color:var(--muted);padding:30px 0">Tu carrito está vacío. Elige tu vehículo y añade la pieza.</p>`;
  $('#subtotal').textContent=money((CART.total_price||0)/100);
  document.querySelectorAll('[data-go]').forEach(b=>{b.disabled=!parts().length});
  const est=coreEstimate(),hasFee=CART.items.some(isFee);
  document.querySelectorAll('.coreest').forEach(el=>{el.hidden=!est.n||hasFee;el.innerHTML=`<span>+ Core reembolsable (${est.n}) · se añade al pagar y se devuelve al entregar la pieza vieja</span><b>${money(est.total)}</b>`});
  refreshBots();floatBar();
}
/* barra flotante: aparece al haber piezas en el carrito -> Pagar (grande) + Remover / Remover todo (pequeño) */
let FB;
function floatBar(){
  if(/^\/(cart|checkouts?)(\/|$)/.test(location.pathname))return;
  if(!FB){FB=document.createElement('div');FB.className='fbar';FB.setAttribute('role','region');FB.setAttribute('aria-label','Tu carrito');
    FB.innerHTML='<button type="button" class="fb-rm"></button><button type="button" class="fb-go" data-go><span class="fb-t"></span><b class="fb-p mono"></b><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>';
    document.body.appendChild(FB);
    FB.querySelector('.fb-rm').onclick=async e=>{const b=e.currentTarget;b.disabled=true;
      try{const ps=parts();
        if(ps.length===1&&ps[0].quantity===1)await changeLine(ps[0].key,0);
        else{await NF('/cart/clear.js',{method:'POST',headers:JH});await loadCart()}
        toast('Carrito vacío')}catch(err){toast('No se pudo remover. Intenta de nuevo.')}
      b.disabled=false}}
  const n=parts().reduce((a,i)=>a+i.quantity,0),sub=parts().reduce((a,i)=>a+i.final_line_price,0);
  FB.querySelector('.fb-rm').textContent=n>1?'Remover todo':'Remover';
  FB.querySelector('.fb-t').innerHTML=`Pagar<span class="fb-n"> · ${n} ${n===1?'pieza':'piezas'}</span>`;
  FB.querySelector('.fb-p').textContent=money(sub/100);
  FB.querySelector('.fb-go').disabled=!n;
  FB.classList.toggle('on',n>0);document.body.classList.toggle('has-fbar',n>0);
}
// Pagar: pone el core que marcan las reglas de Fee Rules (window.Canteen) y entra al checkout.
// El botón no se llama name="checkout" a propósito: si no, la app lo clona y su clon no añade el core.
async function goCheckout(){
  document.querySelectorAll('[data-go]').forEach(b=>{b.disabled=true});
  try{
    const rules=feeRules();
    if(rules.length){
      await fetchCart();
      const want={};rules.forEach(r=>want[r.id]=0);
      parts().forEach(it=>{const r=rules.find(r=>r.set.has(+it.variant_id));if(r)want[r.id]+=it.quantity});
      const upd={};
      for(const id in want){const have=CART.items.filter(i=>i.variant_id==id).reduce((a,i)=>a+i.quantity,0);if(have!==want[id])upd[id]=want[id]}
      if(Object.keys(upd).length)await NF('/cart/update.js',{method:'POST',headers:JH,body:JSON.stringify({updates:upd})});
    }
  }catch(e){}
  location.href='/checkout';
}
document.addEventListener('click',e=>{const b=e.target.closest('[data-go]');if(!b||b.disabled)return;e.preventDefault();goCheckout()});
/* botón de compra de las tarjetas: "Comprar ahora" -> Añadido al carrito + cantidad + Remover */
const lineOf=vid=>parts().find(i=>i.variant_id==vid);
const qtyOf=vid=>parts().filter(i=>i.variant_id==vid).reduce((a,i)=>a+i.quantity,0);
const CHECK='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M4 12l5 5L20 6"/></svg>';
function botHtml(b){
  const q=qtyOf(b.dataset.v);
  if(!q)return `<button class="add" type="button"${b.hasAttribute('data-off')?' disabled':''}>${b.hasAttribute('data-off')?'Llamar para precio':'Comprar ahora'}</button>`;
  return `<span class="added">${CHECK}Añadido al carrito</span><div class="qty"><button type="button" data-bq="-1" aria-label="Menos">−</button><span>${q}</span><button type="button" data-bq="1" aria-label="Más">+</button></div><button class="rm" type="button">Remover</button>`;
}
function refreshBots(){
  document.querySelectorAll('.bot[data-v]').forEach(b=>{
    const q=String(qtyOf(b.dataset.v))+(b.hasAttribute('data-off')?'x':'');
    if(b.dataset.q===q)return;
    b.dataset.q=q;b.innerHTML=botHtml(b);
  });
}
function openCart(o){document.body.classList.toggle('drawer-open',o);$('#drawer').classList.toggle('on',o);$('#scrim').classList.toggle('on',o)}
$('#cartbtn').addEventListener('click',e=>{e.preventDefault();openCart(true)});
$('#closecart').onclick=$('#scrim').onclick=()=>openCart(false);
addEventListener('keydown',e=>{if(e.key==='Escape')openCart(false)});
$('#lines').addEventListener('click',e=>{const b=e.target.closest('button[data-d]');if(!b)return;b.disabled=true;changeLine(b.dataset.k,Math.max(0,+b.dataset.q+ +b.dataset.d))});
document.addEventListener('click',async e=>{
  const bot=e.target.closest('.bot[data-v]');if(!bot)return;
  const add=e.target.closest('.add'),step=e.target.closest('[data-bq]'),rm=e.target.closest('.rm');
  if(!add&&!step&&!rm)return;
  e.preventDefault();if(add&&add.disabled)return;
  const vid=bot.dataset.v,line=lineOf(vid);
  bot.classList.add('busy');
  try{
    if(add){await addToCart(vid,1);toast(`${bot.dataset.sku||'Pieza'} añadida al carrito`)}
    else if(line){await changeLine(line.key,rm?0:Math.max(0,line.quantity+ +step.dataset.bq))}
  }catch(err){toast(err.message)}
  bot.classList.remove('busy');bot.dataset.q='';refreshBots();
});
/* formulario de la página de producto */
const buy=document.getElementById('buy');
if(buy)buy.addEventListener('submit',async e=>{
  const btn=e.submitter;
  e.preventDefault();
  if(btn&&btn.value==='/checkout'){ // Comprar ahora: añade (con su core) y va directo al pago
    btn.disabled=true;
    try{await addToCart(buy.querySelector('[name=id]').value,parseInt(buy.querySelector('[name=quantity]').value,10)||1);goCheckout()}
    catch(err){toast(err.message);btn.disabled=false}
    return;
  }
  const q=parseInt(buy.querySelector('[name=quantity]').value,10)||1;
  if(btn)btn.disabled=true;
  try{
    await addToCart(buy.querySelector('[name=id]').value,q);
    if(btn){const txt=btn.textContent;btn.classList.add('added-ok');btn.textContent='✓ Añadido al carrito';
      setTimeout(()=>{btn.classList.remove('added-ok');btn.textContent=txt},2200)}
    setTimeout(()=>openCart(true),450);
  }catch(err){toast(err.message)}
  if(btn)btn.disabled=false;
});
loadCart();
// las reglas de Fee Rules llegan un poco después: en cuanto estén, cuadra los cargos una vez
(async()=>{for(let i=0;i<24&&!feeRules().length;i++)await new Promise(r=>setTimeout(r,250));if(feeRules().length)drawCart()})();

/* ---------- Mi garaje: los carros del cliente, cada uno con "su tienda" ---------- */
let veh=store.get('pp_vehicle',null);
const vkey=v=>v?v.mk+'|'+v.md+'|'+v.yr:'';
let GAR=store.get('pp_garage',[]).filter(v=>v&&v.mk&&v.md&&v.yr);
if(veh&&!GAR.some(g=>vkey(g)===vkey(veh)))GAR.unshift(veh);
const saveGar=()=>store.set('pp_garage',GAR.slice(0,8));
const fitsVeh=(D,pi,v)=>D.FITS[pi].some(([mk,md,a,b])=>mk===v.mk&&md===v.md&&v.yr>=a&&v.yr<=b);
const countFor=(D,v)=>{let n=0;for(let i=0;i<D.P.length;i++)if(fitsVeh(D,i,v))n++;return n};
const CAR='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 17h14v-4l-2-5H7l-2 5z"/><path d="M3 13h18"/><circle cx="7.5" cy="17" r="1.6"/><circle cx="16.5" cy="17" r="1.6"/></svg>';
// tablilla de Puerto Rico con el carro del cliente
const plate=(v,big)=>`<div class="plate${big?' big':''}${v.md.length>10?' xl':v.md.length>7?' l':''}"><span class="pl-t">Puerto Rico</span><b>${esc(v.md)}</b><span class="pl-b">${esc(v.mk)} · ${v.yr}</span></div>`;
function garagePill(){
  const g=$('#garage');if(!g)return;
  g.classList.add('show');g.classList.toggle('has',!!veh);
  g.innerHTML=CAR+`<span>${veh?esc(veh.md)+' '+veh.yr:'Mi garaje'}</span>`+(GAR.length>1?`<em>${GAR.length}</em>`:'');
  g.setAttribute('aria-label',veh?`Mi garaje: ${veh.mk} ${veh.md} ${veh.yr}`:'Mi garaje');
  let x=$('#garage-x');
  if(!x){x=document.createElement('button');x.type='button';x.id='garage-x';x.className='garage-x';x.innerHTML='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    g.after(x);x.onclick=e=>{e.stopPropagation();clearVehicle(true)}}
  x.hidden=!veh;if(veh)x.setAttribute('aria-label',`Quitar ${veh.md} ${veh.yr}`);
}
// quitar el carro activo en un toque, con "Deshacer" por si fue sin querer
let UT;
function clearVehicle(undo,removeFromGarage){
  const prev=veh,prevGar=GAR.slice();if(!prev)return;
  veh=null;store.set('pp_vehicle',null);
  if(removeFromGarage){GAR=GAR.filter(g=>vkey(g)!==vkey(prev));saveGar()}
  garagePill();
  if(CFG.home&&window.__pprClearVehicle)window.__pprClearVehicle();
  else if(document.getElementById('fitbox')||document.getElementById('colapp'))setTimeout(()=>location.reload(),undo?900:0)
  if(!undo)return;
  let t=$('#utoast');if(!t){t=document.createElement('div');t.id='utoast';t.className='utoast';t.setAttribute('role','status');document.body.appendChild(t)}
  t.innerHTML=`<span>${removeFromGarage?'Borraste':'Quitaste'} tu ${esc(prev.md)} ${prev.yr}</span><button type="button">Deshacer</button>`;
  t.classList.add('on');clearTimeout(UT);UT=setTimeout(()=>t.classList.remove('on'),5000);
  t.querySelector('button').onclick=()=>{t.classList.remove('on');GAR=prevGar;saveGar();useVehicle(prev)};
}
function useVehicle(v){
  veh=v;store.set('pp_vehicle',v);
  if(v){GAR=[v,...GAR.filter(g=>vkey(g)!==vkey(v))];saveGar()}
  garagePill();closeGarage();
  if(CFG.home&&window.__pprSetVehicle)window.__pprSetVehicle(v);
  else if(v)location.href='/?mk='+encodeURIComponent(v.mk)+'&md='+encodeURIComponent(v.md)+'&yr='+v.yr+'#resultados';
  else location.reload();
}
let GP;
function closeGarage(){if(GP){GP.classList.remove('on');document.body.classList.remove('gar-open')}}
async function openGarage(){
  if(!GP){GP=document.createElement('div');GP.className='garage';GP.setAttribute('role','dialog');GP.setAttribute('aria-label','Mi garaje');document.body.appendChild(GP);
    GP.addEventListener('click',e=>{if(e.target===GP)closeGarage()});}
  GP.innerHTML='<div class="gp"><p class="gp-load">Abriendo tu garaje…</p></div>';
  GP.classList.add('on');document.body.classList.add('gar-open');
  const D=await catalog();drawGarage(D);
}
function drawGarage(D){
  const act=veh&&GAR.find(g=>vkey(g)===vkey(veh));
  const others=GAR.filter(g=>vkey(g)!==vkey(veh));
  const mkOpts=Object.keys(D.F).sort().map(m=>`<option>${esc(m)}</option>`).join('');
  GP.innerHTML=`<div class="gp">
    <div class="gp-h"><div><p class="eyebrow">Mi garaje</p><h3>${act?'Tu carro, tu tienda.':'Guarda tu carro.'}</h3></div><button type="button" class="gp-x" aria-label="Cerrar">✕</button></div>
    ${act?`<div class="gp-act">${plate(act,true)}<div class="gp-ai">${(n=>`<b>${n}</b> ${n===1?'pieza le sirve':'piezas le sirven'} a tu ${esc(act.md)}`)(countFor(D,act))}<a class="btn-store" href="/?mk=${encodeURIComponent(act.mk)}&md=${encodeURIComponent(act.md)}&yr=${act.yr}#resultados" data-store>Entrar a su tienda →</a><button type="button" class="gp-del">Borrar este carro</button></div></div>`
      :`<p class="gp-intro">Guarda tu carro una vez y la web te enseña solo las piezas que le sirven, en todas las páginas.</p>`}
    ${others.length?`<p class="gp-sub">Otros carros</p><div class="gp-list">${others.map(v=>`<div class="gp-row" data-v="${esc(vkey(v))}">${plate(v)}<span class="gp-n">${(n=>n+(n===1?' pieza':' piezas'))(countFor(D,v))}</span><button type="button" class="gp-use">Usar</button><button type="button" class="gp-rm" aria-label="Quitar ${esc(v.md)}">✕</button></div>`).join('')}</div>`:''}
    <form class="gp-add" autocomplete="off"><p class="gp-sub">${GAR.length?'Añadir otro carro':'Añade tu carro'}</p>
      <div class="gp-sel"><select name="mk" aria-label="Marca"><option value="">Marca</option>${mkOpts}</select><select name="md" aria-label="Modelo" disabled><option value="">Modelo</option></select><select name="yr" aria-label="Año" disabled><option value="">Año</option></select></div>
      <button class="gp-save" type="submit" disabled>Guardar en mi garaje</button></form>
    ${act?'<button type="button" class="gp-off">Comprar sin vehículo</button>':''}
  </div>`;
  const f=GP.querySelector('.gp-add'),[smk,smd,syr]=f.querySelectorAll('select'),sv=f.querySelector('.gp-save');
  smk.onchange=()=>{const m=D.F[smk.value];smd.disabled=!m;smd.innerHTML='<option value="">Modelo</option>'+(m?Object.keys(m).sort().map(x=>`<option>${esc(x)}</option>`).join(''):'');syr.disabled=true;syr.innerHTML='<option value="">Año</option>';sv.disabled=true};
  smd.onchange=()=>{const l=(D.F[smk.value]||{})[smd.value];syr.disabled=!l;const ys=new Set();(l||[]).forEach(([a,b])=>{for(let y=a;y<=b;y++)ys.add(y)});syr.innerHTML='<option value="">Año</option>'+[...ys].sort((a,b)=>b-a).map(y=>`<option>${y}</option>`).join('');sv.disabled=true};
  syr.onchange=()=>{sv.disabled=!syr.value};
  f.onsubmit=e=>{e.preventDefault();if(!syr.value)return;useVehicle({mk:smk.value,md:smd.value,yr:+syr.value})};
  GP.querySelector('.gp-x').onclick=closeGarage;
  const st=GP.querySelector('[data-store]');if(st&&CFG.home)st.onclick=e=>{e.preventDefault();useVehicle(act)};
  const del=GP.querySelector('.gp-del');if(del)del.onclick=()=>{closeGarage();clearVehicle(true,true)};
  const off=GP.querySelector('.gp-off');if(off)off.onclick=()=>{closeGarage();clearVehicle(true)};
  GP.querySelectorAll('.gp-row').forEach(r=>{const v=GAR.find(g=>vkey(g)===r.dataset.v);
    r.querySelector('.gp-use').onclick=()=>useVehicle(v);
    r.querySelector('.gp-rm').onclick=()=>{GAR=GAR.filter(g=>vkey(g)!==r.dataset.v);saveGar();garagePill();drawGarage(D)}});
}
addEventListener('keydown',e=>{if(e.key==='Escape')closeGarage()});
garagePill();
$('#garage').addEventListener('click',openGarage);

/* ---------- catálogo (se carga una vez) ---------- */
let CATP=null;
function catalog(){return CATP||(CATP=NF(CFG.catalog).then(r=>r.json()).then(D=>{
  const FITS=D.P.map(()=>[]);
  for(const mk in D.F)for(const md in D.F[mk])for(const [a,b,pi,si] of D.F[mk][md])FITS[pi].push([mk,md,a,b,si]);
  D.FITS=FITS;
  D.byHandle=new Map(D.P.map((p,i)=>[p[6],i]));
  D.fitText=pi=>{const f=FITS[pi];if(!f.length)return D.P[pi][7]||'Consulta la guía de compatibilidad';
    const seen=new Map();for(const [mk,md,a,b] of f){const k=mk+' '+md;const o=seen.get(k);seen.set(k,o?[Math.min(o[0],a),Math.max(o[1],b)]:[a,b])}
    const arr=[...seen].map(([k,[a,b]])=>k+' '+(a===b?a:a+'–'+b));
    return arr.slice(0,2).join(' · ')+(arr.length>2?` · +${arr.length-2} más`:'')};
  const norm=s=>s.toLowerCase().replace(/[^a-z0-9]/g,'');D.norm=norm;
  D.SKUIDX=D.P.map(p=>norm(p[0]));
  D.MODELS=[];for(const mk in D.F)for(const md in D.F[mk])D.MODELS.push([mk,md,norm(mk+md),norm(md)]);
  return D;
}))}

/* ---------- buscador: mientras escribes salen los vehículos y TODAS las piezas que les sirven ---------- */
const q=$('#q'),sugg=$('#sugg');let sel=-1,opts=[],SRES=[],SSHOWN=0,SQ='';
const CATWORDS={rack:'rack',cremallera:'rack',pinion:'rack',steering:'rack',direccion:'rack',alternador:'alternador',alternator:'alternador',
  starter:'starter',arranque:'starter',motorarranque:'starter',radiador:'radiador',radiator:'radiador',bomba:'bomba',pump:'bomba',
  booster:'booster',shock:'shock',shocks:'shock',strut:'shock',struts:'shock',amortiguador:'shock',amortiguadores:'shock'};
function searchAll(D,raw){
  const words=raw.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').split(/[\s,·\/]+/).filter(Boolean);
  let yr=null,cat=null;const rest=[];
  for(const w of words){
    if(/^(19[5-9]\d|20[0-4]\d)$/.test(w)){yr=+w;continue}
    const c=CATWORDS[D.norm(w)];if(c&&!cat){cat=c;continue}
    if(['de','para','del','el','la','power','and','&','y'].includes(w))continue;
    rest.push(D.norm(w));
  }
  const toks=rest.filter(Boolean),all=toks.join('');
  // vehículos: cada palabra escrita es el comienzo de una palabra de la marca o el modelo (o del modelo junto)
  let vehs=[];
  if(toks.length)vehs=D.MODELS.filter(([mk,md])=>{
    const ws=(mk+' '+md).toLowerCase().split(/[\s-]+/).map(D.norm),joined=D.norm(md),mj=D.norm(mk+md);
    return toks.every(t=>ws.some(w=>w.startsWith(t)))||joined.startsWith(all)||mj.startsWith(all);
  });
  const vkey=new Set(vehs.map(v=>v[0]+'|'+v[1]));
  const hits=new Map();
  if(vehs.length){
    D.FITS.forEach((f,pi)=>{for(const [mk,md,a,b] of f)if(vkey.has(mk+'|'+md)&&(!yr||(a<=yr&&yr<=b))){hits.set(pi,mk+' '+md+(yr?' '+yr:''));break}});
  }
  if(all.length>=2)D.SKUIDX.forEach((s,i)=>{if(s.includes(all)&&!hits.has(i))hits.set(i,'')});
  if(!toks.length&&cat)D.P.forEach((p,i)=>hits.set(i,''));
  let items=[...hits].map(([pi,why])=>({pi,why})).filter(x=>!cat||D.P[x.pi][1]===cat);
  items.sort((x,y)=>(D.P[y.pi][4]-D.P[x.pi][4])||((D.P[y.pi][3]>0)-(D.P[x.pi][3]>0))||ORDER.indexOf(D.P[x.pi][1])-ORDER.indexOf(D.P[y.pi][1]));
  return {vehs:vehs.slice(0,12),items,yr,cat};
}
function sRow(D,x,k){
  const [sku,cat,kind,price,av,vid]=D.P[x.pi];const n=qtyOf(vid);
  return `<div class="srow" role="option" data-k="${k}"><img src="${img(cat)}" alt=""><span class="si"><b class="mono">${esc(sku)}</b> · ${esc(kind)}<br><small>${esc(x.why?('Le sirve a '+x.why):D.fitText(x.pi))}</small></span>
    <span class="sp"><b class="mono">${price>0?money(price):'Consultar'}</b><small class="${av?'ok':'no'}">${av?'Disponible':'Por encargo'}</small></span>
    ${price>0?`<button type="button" class="sadd${n?' in':''}" data-v="${vid}" data-sku="${esc(sku)}" aria-label="Añadir ${esc(sku)} al carrito">${n?CHECK+n:'+'}</button>`:''}</div>`;
}
function sMore(D){
  const end=Math.min(SRES.length,SSHOWN+40);let h='';
  for(let k=SSHOWN;k<end;k++)h+=sRow(D,SRES[k],opts.length-SRES.length+k);
  SSHOWN=end;const box=sugg.querySelector('.slist');if(box)box.insertAdjacentHTML('beforeend',h);
}
async function runSearch(){
  const D=await catalog();SQ=q.value;const t=D.norm(q.value);sel=-1;if(t.length<2){sugg.hidden=true;return}
  const {vehs,items,yr,cat}=searchAll(D,q.value);
  opts=[...vehs.map(v=>({t:'v',v,yr})),...items.map(x=>({t:'s',i:x.pi}))];SRES=items;SSHOWN=0;
  if(!opts.length){sugg.innerHTML=`<div class="h">Sin resultados para “${esc(q.value)}”. Pulsa Enter para buscar en toda la tienda.</div>`;sugg.hidden=false;return}
  let h='';
  if(vehs.length)h+='<div class="h">Vehículos</div><div class="schips">'+vehs.map((v,k)=>`<button type="button" class="schip" data-k="${k}">${esc(v[0])} ${esc(v[1])}${yr?' '+yr:''}</button>`).join('')+'</div>';
  h+=items.length?`<div class="h">Piezas <span class="sn">${items.length.toLocaleString('en-US')}</span>${cat?' · '+esc(CATS[cat].n):''}</div><div class="slist"></div>`
    :`<div class="h">${yr?'No tenemos piezas activas para ese año.':'Sin piezas activas para esa búsqueda.'} Elige el vehículo para ver la guía.</div>`;
  sugg.innerHTML=h;sMore(D);sugg.hidden=false;sugg.scrollTop=0;
}
let sT;q.addEventListener('input',()=>{clearTimeout(sT);sT=setTimeout(runSearch,90)});
q.addEventListener('focus',()=>{catalog();if(q.value.trim().length>=2)runSearch()});
sugg.addEventListener('scroll',async()=>{if(SSHOWN<SRES.length&&sugg.scrollTop+sugg.clientHeight>sugg.scrollHeight-200)sMore(await catalog())});
async function pick(o){
  const D=await catalog();sugg.hidden=true;
  if(o.t==='s'){location.href='/products/'+D.P[o.i][6];return}
  const [mk,md]=o.v;q.value='';
  if(CFG.home&&window.__pprPickModel)window.__pprPickModel(mk,md,o.yr);
  else location.href='/?mk='+encodeURIComponent(mk)+'&md='+encodeURIComponent(md)+(o.yr?'&yr='+o.yr:'');
}
sugg.addEventListener('mousedown',async e=>{
  const ad=e.target.closest('.sadd');
  if(ad){e.preventDefault();if(ad.disabled)return;ad.disabled=true;
    try{await addToCart(ad.dataset.v,1);toast(`${ad.dataset.sku} añadida al carrito`);const n=qtyOf(ad.dataset.v);ad.classList.add('in');ad.innerHTML=CHECK+n}
    catch(err){toast(err.message)}ad.disabled=false;return}
  const b=e.target.closest('[data-k]');if(b){e.preventDefault();pick(opts[+b.dataset.k])}
});
q.addEventListener('keydown',e=>{
  const bs=[...sugg.querySelectorAll('[data-k]')];
  if((e.key==='ArrowDown'||e.key==='ArrowUp')&&bs.length&&!sugg.hidden){e.preventDefault();sel=(sel+(e.key==='ArrowDown'?1:-1)+bs.length)%bs.length;bs.forEach((b,i)=>b.classList.toggle('on',i===sel));bs[sel].scrollIntoView({block:'nearest'})}
  else if(e.key==='Enter'&&sel>=0){e.preventDefault();pick(opts[+bs[sel].dataset.k])}
  else if(e.key==='Enter'&&opts.length&&opts[0].t==='v'&&opts.filter(o=>o.t==='v').length===1){e.preventDefault();pick(opts[0])}
  else if(e.key==='Escape')sugg.hidden=true;
});
q.addEventListener('blur',()=>setTimeout(()=>sugg.hidden=true,150));

/* ---------- página de producto: compatibilidad ---------- */
const fitbox=document.getElementById('fitbox');
if(fitbox)catalog().then(D=>{
  const pi=D.byHandle.get(fitbox.dataset.handle);
  const rows=pi==null?[]:D.FITS[pi].slice().sort((a,b)=>a[0].localeCompare(b[0])||a[1].localeCompare(b[1])||a[2]-b[2]);
  const tb=$('#fittable');
  if(!rows.length){tb.innerHTML=`<p class="sub">Esta pieza aún no tiene guía cargada. Llámanos y te confirmamos si le sirve a tu carro.</p>`}
  else tb.innerHTML=`<div class="tscroll"><table><thead><tr><th>Marca</th><th>Modelo</th><th>Años</th><th>Motor / posición</th></tr></thead><tbody>${rows.map(([mk,md,a,b,si])=>`<tr><td>${esc(mk)}</td><td>${esc(md)}</td><td class="mono">${a===b?a:a+'–'+b}</td><td>${esc(D.S[si]||'Todos')}</td></tr>`).join('')}</tbody></table></div>`;
  const chk=$('#fitcheck');
  if(veh&&chk){
    const ok=rows.some(([mk,md,a,b])=>mk===veh.mk&&md===veh.md&&veh.yr>=a&&veh.yr<=b);
    chk.hidden=false;chk.className='fitcheck '+(ok?'ok':'no');
    chk.innerHTML=ok?`<b>Le sirve a tu ${esc(veh.mk)} ${esc(veh.md)} ${veh.yr}.</b>`
      :`<b>No aparece para tu ${esc(veh.mk)} ${esc(veh.md)} ${veh.yr}.</b> <a href="/?garaje=1#resultados">Ver las piezas que sí le sirven</a>`;
  }
});

/* ---------- campo de iconos PR del hero ----------
   El icono del logo repetido miles de veces, tenue y a la deriva. Franjas rojas lo recorren;
   con el cursor encima se encienden donde pasas y se apartan (mismo gesto que la landing de vendedores de TuPlanta). */
function iconField(zona,cv){
  if(!zona||!cv)return;
  const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches,fine=matchMedia('(pointer:fine)').matches;
  const ctx=cv.getContext('2d'),src=new Image();src.src=CFG.a+'ppr-icon.png';
  const GX=34,GY=20,IH=8;let W=0,H=0,dpr=1,pts=[],sw,sr,run=true;
  const m={x:0,y:0,on:0,k:0,px:0,py:0,ex:0,ey:0};
  function sprite(color){
    const h=IH*2*dpr,w=h*src.width/src.height,c=document.createElement('canvas');c.width=Math.ceil(w)+2;c.height=Math.ceil(h)+2;
    const x=c.getContext('2d');x.drawImage(src,1,1,w,h);x.globalCompositeOperation='source-in';x.fillStyle=color;x.fillRect(0,0,c.width,c.height);return c;
  }
  function build(){
    if(!src.complete||!src.width)return;
    const r=zona.getBoundingClientRect();dpr=Math.min(devicePixelRatio||1,2);
    W=r.width;H=r.height;cv.width=W*dpr;cv.height=H*dpr;sw=sprite('#ffffff');sr=sprite('#ff0032');pts=[];
    for(let y=-GY;y<H+GY*2;y+=GY)for(let x=-GX;x<W+GX*2;x+=GX)
      pts.push({x:x+((y/GY)%2)*GX/2+(Math.random()-.5)*4,y:y+(Math.random()-.5)*3,ph:Math.random()*6.28,rot:(Math.random()-.5)*.25});
    if(reduce)draw(0);
  }
  function draw(t){
    if(!sw)return;
    ctx.setTransform(1,0,0,1,0,0);ctx.clearRect(0,0,cv.width,cv.height);
    m.ex+=(m.px-m.ex)*.025;m.ey+=(m.py-m.ey)*.025;m.k+=(m.on-m.k)*.05;
    const drift=reduce?0:(t*.004)%GX,ox=drift-m.ex*14,oy=drift*.3-m.ey*6;
    const HALF=.3,L=1+HALF*2,c=((t/15000)%1)*L-HALF,R=Math.max(170,W*.14);
    const bw=sw.width/dpr/2,bh=sw.height/dpr/2;
    for(const p of pts){
      let x=(p.x+ox)%(W+GX*2)-GX,y=(p.y+oy)%(H+GY*2)-GY,kc=0,ks=0;
      if(m.k>.01){const dx=x-m.x,dy=y-m.y,d=Math.hypot(dx,dy);
        if(d<R){kc=1-d/R;kc=kc*kc*(3-2*kc)*m.k;const push=kc*9/(d||1);x+=dx*push;y+=dy*push}}
      if(!reduce){const dd=((((x/W)*.8+(y/H)*.2-c)%L)+L)%L,dist=Math.min(dd,L-dd);ks=Math.max(0,1-dist/HALF);ks=ks*ks*(1-m.k)}
      const dim=Math.min(1,.35+.65*Math.max(0,(x/W-.12)/.38));
      const k=Math.max(kc,ks*.55),tw=reduce?.5:.5+.5*Math.sin(t*.0006+p.ph),sc=1+k*.6;
      ctx.setTransform(dpr*sc,0,0,dpr*sc,x*dpr,y*dpr);ctx.rotate(p.rot);
      ctx.globalAlpha=(.025+tw*.025)*dim;ctx.drawImage(sw,-bw/2,-bh/2,bw,bh);
      if(k>.02){ctx.globalAlpha=k*.5*dim;ctx.drawImage(sr,-bw/2,-bh/2,bw,bh)}
    }
  }
  function loop(t){if(run)draw(t);requestAnimationFrame(loop)}
  src.onload=build;
  if('ResizeObserver' in window)new ResizeObserver(build).observe(zona);
  if('IntersectionObserver' in window)new IntersectionObserver(e=>{run=e[0].isIntersecting}).observe(zona);
  if(fine&&!reduce){
    zona.addEventListener('pointermove',e=>{const r=zona.getBoundingClientRect();m.x=e.clientX-r.left;m.y=e.clientY-r.top;m.on=1;m.px=m.x/r.width-.5;m.py=m.y/r.height-.5});
    zona.addEventListener('pointerleave',()=>{m.on=0;m.px=m.py=0});
  }
  build();if(!reduce)requestAnimationFrame(loop);
}

/* ---------- tarjetas de producto (portada y colecciones) ---------- */
function cardKit(D){
const P=D.P,fitText=D.fitText;
function card({pi,note}){
  const [sku,cat,kind,price,av,vid,handle]=P[pi];
  return `<article class="card" data-pi="${pi}">
    <a class="pic" href="/products/${esc(handle)}"><img src="${img(cat)}" alt="${esc(CATS[cat].s)}" loading="lazy"></a>
    <div class="body">
      <div class="kind">${esc(kind)}</div>
      <a class="sku mono" href="/products/${esc(handle)}">${esc(sku)}</a>
      ${veh&&fitsVeh(D,pi,veh)?`<div class="fitme">${CHECK}Le sirve a tu ${esc(veh.md)} ${veh.yr}</div>`:`<div class="fits">${esc(fitText(pi))}</div>`}
      ${note?`<div class="note">${esc(note)}</div>`:''}
      <div class="foot">
        <div class="price">${price>0?money(price):'Consultar'}</div>
        <div class="stock ${av?'ok':'no'}"><i></i>${av?'Disponible':'Por encargo'}</div>
      </div>
      <div class="bot" data-v="${vid}" data-sku="${esc(sku)}"${price>0?'':' data-off'}></div>
    </div></article>`;
}

// precio y disponibilidad en vivo desde Shopify
const LIVE=new Map();
function live(pis){
  pis.forEach(pi=>{
    const h=P[pi][6];
    const p=LIVE.get(h)||NF('/products/'+h+'.js').then(r=>r.ok?r.json():null).catch(()=>null);
    LIVE.set(h,p);
    p.then(j=>{
      const el=document.querySelector(`.card[data-pi="${pi}"]`);
      if(!el)return;
      if(!j){el.remove();return}
      const v=j.variants[0];
      P[pi][3]=v.price/100;P[pi][4]=v.available?1:0;P[pi][5]=v.id;
      el.querySelector('.price').textContent=v.price>0?money(v.price/100):'Consultar';
      const st=el.querySelector('.stock');st.className='stock '+(v.available?'ok':'no');st.innerHTML='<i></i>'+(v.available?'Disponible':'Por encargo');
      const b=el.querySelector('.bot');b.dataset.v=v.id;b.toggleAttribute('data-off',!(v.price>0));b.dataset.q='';refreshBots();
    });
  });
}

return {card,live};
}

if(document.querySelector('.of-hero'))iconField(document.querySelector('.of-hero'),document.getElementById('icons'));

/* ---------- colección: filtro por vehículo, lista rápida y "Ver más" sin recargar ---------- */
const COLCAT={'rack-pinion':'rack','alternators':'alternador','starters':'starter','radiators':'radiador','power-steering-pumps':'bomba','brake-power-boosters':'booster','shock-absorbers':'shock'};
const CATHANDLE=Object.fromEntries(Object.entries(COLCAT).map(([h,c])=>[c,h]));
const colapp=document.getElementById('colapp');
if(colapp&&COLCAT[colapp.dataset.handle])catalog().then(D=>{
  const cat=COLCAT[colapp.dataset.handle],P=D.P,F=D.F,S=D.S,{card,live}=cardKit(D);
  const all=[];P.forEach((p,i)=>{if(p[1]===cat)all.push(i)});
  all.sort((a,b)=>(P[b][4]-P[a][4])||((P[b][3]>0)-(P[a][3]>0)));
  const V={};for(const mk in F)for(const md in F[mk])for(const e of F[mk][md])if(P[e[2]][1]===cat){((V[mk]=V[mk]||{})[md]=V[mk][md]||[]).push(e)}
  const st={v:null,shown:24};
  if(veh&&V[veh.mk]&&V[veh.mk][veh.md])st.v=veh;
  colapp.innerHTML=(colapp.dataset.solo?'':`<nav class="catrow" aria-label="Categorías">${ORDER.map(c=>`<a href="/collections/${CATHANDLE[c]}"${c===cat?' class="on" aria-current="page"':''}>${CATS[c].n}</a>`).join('')}</nav>`)+`
    <div class="colfind"><span class="cf-l">Filtra por tu vehículo</span>
      <select id="cmk" aria-label="Marca"><option value="">Marca</option>${Object.keys(V).sort().map(m=>`<option>${esc(m)}</option>`).join('')}</select>
      <select id="cmd" aria-label="Modelo" disabled><option value="">Modelo</option></select>
      <select id="cyr" aria-label="Año" disabled><option value="">Año</option></select></div>
    <div class="colinfo" id="colinfo"></div><div class="grid" id="cgrid"></div>
    <div class="more"><button type="button" id="cmore" hidden>Ver más</button></div>`;
  const lg=document.getElementById('colgrid');if(lg)lg.hidden=true;
  const cmk=$('#cmk'),cmd=$('#cmd'),cyr=$('#cyr');
  const yearsOf=(mk,md)=>{const s=new Set();for(const [a,b] of V[mk][md])for(let y=a;y<=b;y++)s.add(y);return [...s].sort((a,b)=>b-a)};
  function fillModels(){const mk=cmk.value;cmd.disabled=!mk;cmd.innerHTML='<option value="">Modelo</option>'+(mk?Object.keys(V[mk]).sort().map(m=>`<option>${esc(m)}</option>`).join(''):'');cyr.disabled=true;cyr.innerHTML='<option value="">Año</option>'}
  function fillYears(){const md=cmd.value;cyr.disabled=!md;cyr.innerHTML='<option value="">Año</option>'+(md?yearsOf(cmk.value,md).map(y=>`<option>${y}</option>`).join(''):'')}
  cmk.onchange=()=>{fillModels();if(!cmk.value){st.v=null;st.shown=24;render()}};
  cmd.onchange=()=>{fillYears()};
  cyr.onchange=()=>{if(!cyr.value)return;st.v={mk:cmk.value,md:cmd.value,yr:+cyr.value};veh=st.v;store.set('pp_vehicle',veh);garagePill();st.shown=24;render()};
  if(st.v){cmk.value=st.v.mk;fillModels();cmd.value=st.v.md;fillYears();cyr.value=st.v.yr}
  function items(){
    if(!st.v)return all.map(pi=>({pi}));
    const m=new Map();for(const [a,b,pi,si] of V[st.v.mk][st.v.md])if(st.v.yr>=a&&st.v.yr<=b){const s=m.get(pi)||new Set();if(S[si])s.add(S[si]);m.set(pi,s)}
    return [...m].map(([pi,n])=>({pi,note:[...n].slice(0,3).join(' / ')})).sort((a,b)=>P[b.pi][4]-P[a.pi][4]);
  }
  function render(){
    const it=items(),list=it.slice(0,st.shown);
    $('#colinfo').innerHTML=st.v?`<b>${it.length}</b> ${it.length===1?'pieza le sirve':'piezas le sirven'} a tu ${esc(st.v.mk)} ${esc(st.v.md)} ${st.v.yr} · <button type="button" id="cclear">Ver todas</button>`
      :`<b>${all.length.toLocaleString('en-US')}</b> piezas en esta línea`;
    const cc=$('#cclear');if(cc)cc.onclick=()=>{st.v=null;cmk.value='';fillModels();st.shown=24;render()};
    $('#cgrid').innerHTML=list.length?list.map(card).join(''):`<div class="empty" style="grid-column:1/-1"><h3 style="font-size:20px;color:var(--ink)">No tenemos esta pieza en línea para tu vehículo.</h3><p>Llámanos al <b class="mono" style="color:var(--ink)">(787) 780-6939</b> y te la conseguimos.</p></div>`;
    const mb=$('#cmore');mb.hidden=it.length<=st.shown;mb.textContent=`Ver más (${(it.length-st.shown).toLocaleString('en-US')})`;
    refreshBots();live(list.map(x=>x.pi));
  }
  $('#cmore').onclick=()=>{st.shown+=24;render()};
  render();
});

/* ---------- portada ---------- */
if(!CFG.home)return;
const COUNTS={"rack": 538};
/* hero */
const stage=$('#stage');
const HERO=['alternador','rack','radiador','starter','bomba','booster'];
const heroImgs=HERO.map((c,k)=>{const i=new Image();i.decoding='async';if(k)i.loading='lazy';i.srcset=CFG.a+'ppr-'+c+'.webp 900w, '+CFG.a+'ppr-'+c+'-hd.webp 2000w';i.sizes='(max-width:980px) 92vw, 58vw';i.src=CFG.a+'ppr-'+c+'-hd.webp';i.alt='';stage.appendChild(i);return i});
/* despiece "construction logic": las piezas llegan a su sitio en el despiece, se nombran, se ensamblan
   y un destello deja paso a la foto HD de la pieza armada */
const XPD={"alternador":{"w":2968,"h":1036,"parts":[{"f":"0.webp","x":1,"y":470,"w":87,"h":120},{"f":"1.webp","x":109,"y":369,"w":224,"h":323},{"f":"2.webp","x":343,"y":0,"w":422,"h":1036},{"f":"3.webp","x":784,"y":403,"w":146,"h":242},{"f":"4.webp","x":953,"y":330,"w":551,"h":384},{"f":"5.webp","x":1529,"y":224,"w":383,"h":593},{"f":"6.webp","x":1927,"y":181,"w":650,"h":783},{"f":"7.webp","x":2588,"y":222,"w":378,"h":586}],"names":[]},"bomba":{"w":3031,"h":811,"parts":[{"f":"0.webp","x":1,"y":0,"w":523,"h":811},{"f":"1.webp","x":554,"y":315,"w":131,"h":203},{"f":"2.webp","x":711,"y":80,"w":804,"h":642},{"f":"3.webp","x":1547,"y":210,"w":221,"h":427},{"f":"4.webp","x":1798,"y":228,"w":290,"h":381},{"f":"5.webp","x":2118,"y":192,"w":244,"h":450},{"f":"6.webp","x":2385,"y":20,"w":474,"h":702},{"f":"7.webp","x":2870,"y":334,"w":159,"h":145}],"names":[]},"booster":{"w":2992,"h":873,"parts":[{"f":"0.webp","x":1,"y":13,"w":790,"h":849},{"f":"1.webp","x":800,"y":305,"w":376,"h":268},{"f":"2.webp","x":1204,"y":75,"w":228,"h":727},{"f":"3.webp","x":1479,"y":97,"w":228,"h":686},{"f":"4.webp","x":1779,"y":0,"w":1212,"h":873}],"names":[]},"rack":{"w":2972,"h":447,"parts":[{"f":"0.webp","x":1,"y":236,"w":298,"h":195},{"f":"1.webp","x":320,"y":345,"w":277,"h":49},{"f":"2.webp","x":616,"y":327,"w":28,"h":77},{"f":"3.webp","x":660,"y":299,"w":289,"h":131},{"f":"4.webp","x":969,"y":0,"w":1036,"h":447},{"f":"5.webp","x":2024,"y":299,"w":290,"h":131},{"f":"6.webp","x":2330,"y":327,"w":27,"h":78},{"f":"7.webp","x":2376,"y":345,"w":277,"h":49},{"f":"8.webp","x":2673,"y":236,"w":298,"h":195}],"names":[]},"radiador":{"w":2987,"h":1039,"parts":[{"f":"0.webp","x":1,"y":64,"w":199,"h":111},{"f":"1.webp","x":255,"y":0,"w":246,"h":1039},{"f":"2.webp","x":573,"y":35,"w":108,"h":957},{"f":"3.webp","x":725,"y":48,"w":1573,"h":922},{"f":"4.webp","x":2323,"y":35,"w":100,"h":957},{"f":"5.webp","x":2472,"y":0,"w":267,"h":1037},{"f":"6.webp","x":2769,"y":784,"w":84,"h":78},{"f":"7.webp","x":2888,"y":55,"w":98,"h":814}],"names":[]},"starter":{"w":2965,"h":821,"parts":[{"f":"0.webp","x":2,"y":188,"w":483,"h":496},{"f":"1.webp","x":513,"y":396,"w":261,"h":192},{"f":"2.webp","x":797,"y":349,"w":396,"h":472},{"f":"3.webp","x":1213,"y":374,"w":554,"h":236},{"f":"4.webp","x":1791,"y":308,"w":492,"h":367},{"f":"5.webp","x":2291,"y":0,"w":672,"h":684}],"names":[]}};
const REDUCE=matchMedia('(prefers-reduced-motion: reduce)').matches;
const xpFile=(c,f)=>CFG.a+'ppr-xp-'+c+'-'+f;
const xpPre={};
function preloadXP(c){if(!XPD[c]||xpPre[c])return;xpPre[c]=XPD[c].parts.map(p=>{const i=new Image();i.decoding='async';i.src=xpFile(c,p.f);return i})}
const wait=ms=>new Promise(r=>setTimeout(r,ms));
async function playXP(c){
  const d=XPD[c];
  const box=document.createElement('div');box.className='xp';
  const rot=document.createElement('div');rot.className='xp-rot';rot.style.aspectRatio=d.w+'/'+d.h;
  rot.innerHTML='<i class="xp-axis"></i>'+d.parts.map((p,k)=>`<img class="xp-p" alt="" src="${xpFile(c,p.f)}" style="left:${p.x/d.w*100}%;top:${p.y/d.h*100}%;width:${p.w/d.w*100}%">`).join('')
    +d.parts.map((p,k)=>d.names[k]?`<span class="xp-l${k%2?' dn':''}" style="left:${(p.x+p.w/2)/d.w*100}%;top:${(k%2?(p.y+p.h):p.y)/d.h*100}%"><i></i><b>${esc(d.names[k])}</b></span>`:'').join('');
  const flash=document.createElement('i');flash.className='xp-flash';
  box.append(rot,flash);stage.appendChild(box);
  const parts=[...rot.querySelectorAll('.xp-p')],labels=[...rot.querySelectorAll('.xp-l')],axis=rot.querySelector('.xp-axis');
  await Promise.all(parts.map(i=>i.decode?i.decode().catch(()=>{}):0));
  const W=rot.offsetWidth,n=parts.length;
  // 1) llegan volando desde fuera, en cadena
  axis.animate([{transform:'scaleX(0)',opacity:0},{transform:'scaleX(1)',opacity:1}],{duration:700,easing:'cubic-bezier(.2,.8,.2,1)',fill:'forwards'});
  parts.forEach((el,k)=>{const from=(k-(n-1)/2)*W*.09+(k<n/2?-1:1)*W*.35;
    el.animate([{transform:`translateX(${from}px) rotate(${k%2?14:-14}deg)`,opacity:0},{transform:'none',opacity:1}],
      {duration:760,delay:k*85,easing:'cubic-bezier(.2,1.25,.35,1)',fill:'both'})});
  await wait(760+n*85);
  labels.forEach((l,k)=>l.animate([{opacity:0,transform:'translate(-50%,6px)'},{opacity:1,transform:'translate(-50%,0)'}],{duration:320,delay:k*60,fill:'both',easing:'ease-out'}));
  await wait(1500+n*60);
  // 2) se ensamblan hacia el centro
  labels.forEach(l=>l.animate([{opacity:1},{opacity:0}],{duration:250,fill:'forwards'}));
  axis.animate([{opacity:1},{opacity:0}],{duration:500,fill:'forwards'});
  const C=d.w/2;
  parts.forEach((el,k)=>{const p=d.parts[k],cx=p.x+p.w/2,dx=(C-cx)/d.w*W*.8;
    el.animate([{transform:'none'},{transform:`translateX(${dx}px) scale(.92)`}],{duration:900,easing:'cubic-bezier(.7,0,.2,1)',fill:'forwards'})});
  await wait(820);
  // 3) destello y foto
  flash.animate([{opacity:0,transform:'scale(.6)'},{opacity:1,transform:'scale(1)'},{opacity:0,transform:'scale(1.25)'}],{duration:650,easing:'ease-out',fill:'forwards'});
  box.animate([{opacity:1},{opacity:0}],{duration:420,delay:180,fill:'forwards'}).finished.then(()=>box.remove());
  await wait(160);
}
let hi=0;
async function heroStep(){
  const k=hi,c=HERO[k];hi=(hi+1)%HERO.length;
  $('#tag').innerHTML=`<b>${CATS[c].n}</b>`+(COUNTS[c]?`<span class="stk"><i></i><strong>${COUNTS[c].toLocaleString('en-US')}</strong> en inventario</span>`:'');
  preloadXP(HERO[hi]);
  const xp=!REDUCE&&XPD[c];
  heroImgs.forEach(im=>im.classList.remove('on'));
  if(xp){try{await playXP(c)}catch(e){}}
  heroImgs[k].classList.add('on');
  if(!REDUCE)setTimeout(heroStep,xp?2800:3200);
}
preloadXP(HERO[0]);
heroStep();
iconField($('.hero'),$('#icons'));
catalog().then(D=>{
const P=D.P,S=D.S,F=D.F,fitText=D.fitText,{card,live}=cardKit(D);
const counts={};P.forEach(p=>counts[p[1]]=(counts[p[1]]||0)+1);
const nModels=Object.values(F).reduce((a,m)=>a+Object.keys(m).length,0);
$('#facts').innerHTML=`<span><b>${P.length.toLocaleString('en-US')}</b> piezas</span><span><b>${Object.keys(F).length}</b> marcas</span><span><b>${nModels.toLocaleString('en-US')}</b> modelos</span>`;



/* categorías */
$('#cats').innerHTML=ORDER.filter(c=>counts[c]).map((c,i)=>`<button class="cat" data-cat="${c}">
  <h3>${CATS[c].n}</h3><small>${counts[c].toLocaleString('en-US')} piezas</small>
  <img src="${img(c)}" alt="" loading="lazy">
  <span class="arrow" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span></button>`).join('')
  +`<button class="cat" data-cat="all" style="background:var(--hero);color:var(--hero-ink)"><h3>Busca por vehículo</h3><small style="color:var(--hero-muted)">Marca, modelo y año. Te mostramos solo lo que le sirve.</small><span style="flex:1"></span><span class="arrow" style="position:static;background:var(--red);color:#fff;width:44px;height:44px"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span></button>`;
$('#cats').addEventListener('click',e=>{
  const b=e.target.closest('.cat');if(!b)return;
  if(b.dataset.cat==='all'){$('#top').scrollIntoView();$('#mk').focus();return}
  state.cat=b.dataset.cat;state.shown=24;render(true);
});

/* selector */
const mkS=$('#mk'),mdS=$('#md'),yrS=$('#yr'),go=$('#go');
mkS.innerHTML='<option value="">Elige</option>'+Object.keys(F).map(m=>`<option>${esc(m)}</option>`).join('');
function years(mk,md){const s=new Set();for(const [a,b] of F[mk][md])for(let y=a;y<=b;y++)s.add(y);return [...s].sort((a,b)=>b-a)}
mkS.onchange=()=>{const mk=mkS.value;mdS.disabled=!mk;mdS.innerHTML='<option value="">Elige</option>'+(mk?Object.keys(F[mk]).map(m=>`<option>${esc(m)}</option>`).join(''):'');yrS.disabled=true;yrS.innerHTML='<option value="">—</option>';go.disabled=true};
mdS.onchange=()=>{const md=mdS.value;yrS.disabled=!md;yrS.innerHTML='<option value="">Elige</option>'+(md?years(mkS.value,md).map(y=>`<option>${y}</option>`).join(''):'');go.disabled=true};
yrS.onchange=()=>{go.disabled=!yrS.value};
$('#finder').onsubmit=e=>{e.preventDefault();if(!yrS.value)return;setVehicle({mk:mkS.value,md:mdS.value,yr:+yrS.value})};
function fillSelectors(v){if(!F[v.mk]||!F[v.mk][v.md])return;mkS.value=v.mk;mkS.onchange();mdS.value=v.md;mdS.onchange();if(v.yr){yrS.value=v.yr;go.disabled=false}}
window.__pprPickModel=(mk,md,yr)=>{if(yr&&years(mk,md).includes(yr)){fillSelectors({mk,md,yr});setVehicle({mk,md,yr});return}fillSelectors({mk,md});$('#top').scrollIntoView();setTimeout(()=>yrS.focus(),300)};

/* resultados */
const state={cat:null,shown:24};
function setVehicle(v){veh=v;state.cat=null;state.shown=24;store.set('pp_vehicle',v);if(v){GAR=[v,...GAR.filter(g=>vkey(g)!==vkey(v))];saveGar()}garagePill();render(true)}
window.__pprSetVehicle=v=>{fillSelectors(v);setVehicle(v)};
window.__pprClearVehicle=()=>{mkS.value='';mkS.onchange();state.cat=null;render(false)};
$('#clear').onclick=()=>clearVehicle(true);
$('#clear').innerHTML='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg> Quitar vehículo';
function vehicleMatches(v){
  const m=new Map();const list=(F[v.mk]||{})[v.md]||[];
  for(const [a,b,pi,si] of list)if(v.yr>=a&&v.yr<=b){const s=m.get(pi)||new Set();if(S[si])s.add(S[si]);m.set(pi,s)}
  return [...m].map(([pi,notes])=>({pi,note:[...notes].slice(0,3).join(' / ')}));
}
const FEAT=ORDER.map(c=>{ // una pieza por categoría: la primera disponible con precio y guía de compatibilidad
  let i=P.findIndex((p,k)=>p[1]===c&&p[4]&&p[3]>0&&D.FITS[k].length);
  if(i<0)i=P.findIndex(p=>p[1]===c);return {pi:i}}).filter(x=>x.pi>=0);
// con pocas líneas activas, completa los destacados con más piezas disponibles
for(let k=0;FEAT.length<8&&k<P.length;k++)if(P[k][4]&&P[k][3]>0&&!FEAT.some(x=>x.pi===k))FEAT.push({pi:k});
const FEAT_T=new Set(FEAT.map(x=>P[x.pi][1])).size>1?'Una de cada línea':'Disponibles hoy';

function render(scroll){
  let items,title,eye,sub='';
  if(veh){items=vehicleMatches(veh);eye='Mi garaje · '+veh.mk;title=`La tienda de tu ${veh.md} ${veh.yr}`;sub=items.length?`${items.length} ${items.length===1?'pieza le sirve':'piezas le sirven'} a tu ${veh.mk} ${veh.md} ${veh.yr}. Todo lo que ves aquí es compatible.`:''}
  else if(state.cat){items=P.map((p,i)=>({pi:i})).filter(x=>P[x.pi][1]===state.cat);eye='Categoría';title=CATS[state.cat].n;sub=`${items.length.toLocaleString('en-US')} piezas. Elige tu vehículo arriba para ver solo las que te sirven.`}
  else {items=FEAT;eye='Destacados';title=FEAT_T;sub='Disponibles hoy. Elige tu vehículo para ver todo lo que le sirve.'}
  const byCat={};items.forEach(x=>byCat[P[x.pi][1]]=(byCat[P[x.pi][1]]||0)+1);
  $('#chips').innerHTML=veh&&items.length?`<button class="chip${!state.cat?' on':''}" data-c="">Todas <b>${items.length}</b></button>`+ORDER.filter(c=>byCat[c]).map(c=>`<button class="chip${state.cat===c?' on':''}" data-c="${c}">${CATS[c].n} <b>${byCat[c]}</b></button>`).join(''):'';
  if(veh&&state.cat)items=items.filter(x=>P[x.pi][1]===state.cat);
  if(items!==FEAT)items.sort((a,b)=>(P[b.pi][4]-P[a.pi][4])||ORDER.indexOf(P[a.pi][1])-ORDER.indexOf(P[b.pi][1]));
  $('#reye').textContent=eye;$('#rtitle').textContent=title;$('#rsub').textContent=sub;
  $('#clear').hidden=!veh;const rp=$('#rplate');if(rp)rp.innerHTML=veh?plate(veh,true):'';
  const list=items.slice(0,state.shown);
  $('#grid').innerHTML=list.length?list.map(card).join(''):`<div class="empty" style="grid-column:1/-1"><h3 style="font-size:22px;color:var(--ink)">Todavía no la tenemos en línea.</h3><p>Llámanos al <b class="mono" style="color:var(--ink)">(787) 780-6939</b> y te la conseguimos.</p></div>`;
  $('#morebtn').hidden=items.length<=state.shown;
  $('#morebtn').textContent=`Ver más (${(items.length-state.shown).toLocaleString('en-US')})`;
  refreshBots();
  live(list.map(x=>x.pi));
  if(scroll)$('#resultados').scrollIntoView();
}
$('#chips').onclick=e=>{const c=e.target.closest('.chip');if(!c)return;state.cat=c.dataset.c||null;state.shown=24;render(false)};
$('#morebtn').onclick=()=>{state.shown+=24;render(false)};

/* arranque */
const u=new URLSearchParams(location.search);
if(u.get('mk')&&u.get('md')&&u.get('yr')&&F[u.get('mk')]&&F[u.get('mk')][u.get('md')]){const v={mk:u.get('mk'),md:u.get('md'),yr:+u.get('yr')};fillSelectors(v);veh=v;store.set('pp_vehicle',v);GAR=[v,...GAR.filter(g=>vkey(g)!==vkey(v))];saveGar();garagePill()}
else if(u.get('mk')&&u.get('md')){fillSelectors({mk:u.get('mk'),md:u.get('md')});setTimeout(()=>yrS.focus(),200)}
else if(veh)fillSelectors(veh);
render(u.has('garaje')||u.has('yr'));
});
})();
